<!-- 编辑设备弹框 -->
<template>
  <div class="edit-container">
    <ioc-form ref="iocForm" v-model="devInData" :option="devInOption">
      <template slot="isIndoor">
        <el-select v-model="devInData.isIndoor" @change="selectChange">
          <el-option
            v-for="item in isIndoorList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="longitude">
        <el-input
          v-model="devInData.longitude"
          placeholder="请输入纬度"
        ></el-input>
      </template>
      <template slot="latitude">
        <div>
          <el-input
            v-model="devInData.latitude"
            class="position-set"
            placeholder="请输入纬度"
          ></el-input>
          <el-button
            type="text"
            size="small"
            class="iconfont icon-position map-choose"
            @click="openMap"
          ></el-button>
        </div>
      </template>
      <template slot="buildingName">
        <div>
          <el-input
            v-model="devInData.buildingName"
            class="position-set"
            placeholder="请选择所属楼栋"
          ></el-input>
          <el-button
            type="text"
            size="small"
            class="iconfont icon-position map-choose"
            @click="openBuilding"
          ></el-button>
        </div>
      </template>
    </ioc-form>
    <!--选择设备树-->
    <el-dialog
      v-ops:width="380"
      :title="$t('cameraList.title.chooseArea')"
      width="30%"
      v-dialogDrag
      :visible.sync="deviceTreeShow"
      center
      :modal="false"
    >
      <el-tree
        :data="areaTrData"
        :highlight-current="true"
        :props="defaultProps"
        @node-click="selectAreaNode"
      ></el-tree>
    </el-dialog>
    <!-- 引入gis地图 -->
    <el-dialog
      title="从地图选择"
      width="60%"
      v-dialogDrag
      :visible.sync="showMap"
      @close="mapClose"
      :modal="false"
      @click="mapCancleOpt"
    >
      <div id="map-container"></div>
      <!-- 底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mapConfirmOpt">{{
          $t("taskCenter.button.conform")
        }}</el-button>
        <el-button @click="mapCancleOpt">{{
          $t("taskCenter.button.cancel")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 楼栋树 -->
    <el-dialog
      title="楼栋选择"
      width="70%"
      v-dialogDrag
      :visible.sync="showBuilding"
      @close="mapClose"
      :modal="false"
      @click="mapCancleOpt"
    >
      <!--左侧楼栋树-->
      <div class="flex-container">
        <div class="flex-valign left-tree">
          <div class="left-type_area sbar">
            <div class="flex-between p10 section-mian__toolbar valign-center">
              <span>选择所属楼栋</span>
            </div>
            <div class="tree-container">
              <div class="area-search">
                <el-input
                  v-model="searchString"
                  @change="filterText"
                  @keyup.enter.native="filterText"
                  clearable
                  @clear="clearSearch"
                  placeholder="请输入名称"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="filterText"
                  ></el-button>
                </el-input>
              </div>
              <el-scrollbar class="scroll-bar-view">
                <el-tree
                  v-if="showTree"
                  ref="tree"
                  class="tree-content"
                  :data="treeData"
                  :expand-on-click-node="false"
                  node-key="id"
                  :default-expanded-keys="expandedKeys"
                  render-after-expand
                  :load="asyncLoadNode"
                  :lazy="lazyLoad"
                  :props="treeProps"
                  :highlight-current="true"
                  :filter-node-method="filterNode"
                  @node-click="nodeClick"
                >
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
        </div>

        <!--右侧展示图纸-->
        <!-- 右侧图纸 -->
        <div class="right-img">
          <div class="canvasMain">
            <div
              class="canvasMainT"
              :style="{
                width: vW + '%',
                height: vH + '%',
                marginTop: getMarginTop + 'px',
                marginLeft: getMarinLeft + 'px',
              }"
            >
              <img
                id="building-img"
                :src="
                  rootDefaultDrawing
                    ? '/images/theme/newDark/default-drawing1.jpg'
                    : imgUrl
                "
              />
              <canvas
                id="mycanvas"
                @mousewheel="mouseScroll"
                @DOMMouseScroll="mouseScroll"
                @mousedown="handleDomMoveStart"
                :width="cW"
                :height="cH"
              ></canvas>
            </div>
          </div>
          <div class="marTip">
            <div>【 放大比例 {{ vW }}% 】</div>
          </div>
        </div>
        <img
          class="cam"
          ref="camImg"
          style="visibility: hidden"
          src="@src/common/assets/images/map/resource/electric.png"
          width="20"
          height="20"
          alt=""
        />
      </div>
      <!--操作按钮-->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="camConfirmOpt">确定</el-button>
        <el-button @click="camCancleOpt">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "@src/modules/cameraList/api";
import { Bus } from "$utils";
import deviceMap from "@src/modules/cameraList/components/deviceMap";
import { tableOption } from "../../config/electricTable";
export default {
  data() {
    return {
      isDisplay: {
        display: false,
      },
      isNoDisplay: {
        display: false,
      },
      isShow: false,
      isIndoorList: [
        {
          label: "是",
          value: "1",
        },
        {
          label: "否",
          value: "0",
        },
      ],
      rootDefaultDrawing: true,
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      x: "",
      y: "",
      imgUrl: "",
      showTree: true,
      buildingCode: "",
      showBuilding: false,
      treeData: Object.freeze([]),
      searchString: "",
      expandedKeys: [],
      lazyLoad: false,
      cW: 0,
      cH: 0,
      canvasList: [],
      treeDate: [],
      devInData: {},
      deviceTreeShow: false,
      defaultProps: {
        children: "areaChildren",
        label: "areaDevGroupName",
      },
      // 区域树对象
      areaTrData: [],
      devInOption: tableOption(this),
      // devInOption2: editDev1(this),
      showMap: false,
      point: {},
      areaCopy: {},
    };
  },
  computed: {
    // 视频与容器顶部距离计算
    getMarginTop() {
      return this.marginTop + this.moveYDistance;
    },
    // 视频与容器左边距离计算
    getMarinLeft() {
      return this.marginLeft + this.moveXDistance;
    },
  },
  mixins: [deviceMap],
  watch: {
    vH() {
      this.$nextTick(() => {
        this.getCanvasWH();
      });
    },
    showBuilding(newVal, oldVal) {
      if (oldVal) {
        this.clearCanvas();
      }
    },
  },
  created() {
    console.log(this.devInData, "===============");
  },
  mounted() {
    this.getAreaTree();
    console.log(this.devInData, "===============");
    // if(this.addBtn){
    //   this.devInData={}
    // }
  },
  methods: {
    //输入框选择是否在室内，否：关经纬度，显示楼栋，是：开经纬度，关楼栋
    selectChange(val) {
      console.log(this.$refs.iocForm, "=============this.$refs.iocForm");
      if (val == "1") {
        this.$refs.iocForm.columnOption[0].column[10].display = false;
        this.$refs.iocForm.columnOption[0].column[11].display = false;
        this.$refs.iocForm.columnOption[0].column[9].display = true;
        this.$refs.iocForm.columnOption[0].column[12].display = true;
        this.$refs.iocForm.columnOption[0].column[13].display = true;
        this.$refs.iocForm.columnOption[0].column[14].display = true;
        this.$refs.iocForm.columnOption[0].column[15].display = true;
      } else {
        this.$refs.iocForm.columnOption[0].column[10].display = true;
        this.$refs.iocForm.columnOption[0].column[11].display = true;
        this.$refs.iocForm.columnOption[0].column[9].display = false;
        this.$refs.iocForm.columnOption[0].column[12].display = false;
        this.$refs.iocForm.columnOption[0].column[13].display = false;
        this.$refs.iocForm.columnOption[0].column[14].display = false;
        this.$refs.iocForm.columnOption[0].column[15].display = false;
      }
    },
    // 异步加载树子节点 加载子树数据的方法，仅当 lazy 属性为true 时生效
    asyncLoadNode(node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children);
      } else {
        return resolve([]);
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    queryBuildingTree() {
      this.$fetch(api.queryBuildingTree).then((res) => {
        const result = this.menusDataPro(res.returnObj);
        this.treeData = Object.freeze(result);
        this.expandedKeys = this.expandedKeys.length
          ? this.expandedKeys
          : [this.treeData[0].id];
        // this.$refs.tree.setCheckedKeys([this.devInData.buildingCode] || []);
      });
    },

    // 检索树
    filterText() {
      if (!this.searchString) {
        this.showTree = false;
        this.$nextTick(() => {
          this.showTree = true;
        });
        this.queryBuildingTree();
        return;
      }
      this.$refs.tree.filter(this.searchString.trim());
    },
    //重置
    clearSearch() {
      this.searchString = "";
      this.filterText();
    },
    // 打开楼栋选择
    openBuilding() {
      if (this.devInData.fileCode) {
        this.rootDefaultDrawing = false;
      } else {
        this.rootDefaultDrawing = true;
      }
      this.imgUrl = this.getImgPath(this.devInData.fileCode);
      this.showBuilding = true;
      this.queryBuildingTree();
      this.$nextTick(() => {
        this.clickPoints();
        this.getCanvasWH();
        // 打点回显
        let wb = this.cW / this.devInData.width;
        let hb = this.cH / this.devInData.height;
        setTimeout(() => {
          let ctx = this.initCanvas();

          let img = this.$refs.camImg;
          ctx.drawImage(
            img,
            Math.round(this.devInData.abscissa * wb - 10),
            Math.round(this.devInData.ordinate * hb - 10),
            20,
            20
          );
        }, 2000);
        let _this = this;
        window.onresize = function () {
          _this.watchScreen();
        };
      });
    },
    // 窗口改变事件
    watchScreen() {
      this.getCanvasWH();
    },
    // 点击节点
    nodeClick(data) {
      // 清空已存在的数据和画布
      this.clearCanvas();
      this.x = this.y = "";
      // copy选中数据
      this.areaCopy = {
        name: data.name,
        id: data.id,
      };
      this.parentCode = data.parentCode;
      this.state = 3;
      this.fileList = [];
      console.log(data, "---data");
      if (!data.fileCode) {
        this.rootDefaultDrawing = true;
      } else {
        this.rootDefaultDrawing = false;
        this.devInData.fileCode = data.fileCode;
        this.imgUrl = this.getImgPath(this.devInData.fileCode);
      }
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.buildingCode;
          entity.name = item.buildingName;
          entity.parentCode = item.parentCode;
          entity.type = item.type;
          entity.fileCode = item.fileCode;
          entity.desc = item.desc;
          entity.isLeaf = !item.hasLeaf || !item.subBuildingList;
          if (item.subBuildingList) {
            entity.children = self.menusDataPro(item.subBuildingList);
          }
          result.push(entity);
        });
        return result;
      }
    },
    // 画布添加点击事件
    clickPoints() {
      let that = this;
      var canvas = document.getElementById("mycanvas");
      canvas.addEventListener("click", function (e) {
        that.showCamImg(e);
      });
    },
    // 获取canvas father W H
    getCanvasWH() {
      this.cH = document.querySelector(".canvasMainT").offsetHeight;
      this.cW = document.querySelector(".canvasMainT").offsetWidth;
      this.redrawImg(10);
    },
    // 画布点击回调
    showCamImg(e) {
      this.clearCanvas();
      this.x = e.offsetX;
      this.y = e.offsetY;
      let ctx = this.initCanvas();
      let img = this.$refs.camImg;
      ctx.drawImage(
        img,
        Math.round(this.x - 10),
        Math.round(this.y - 10),
        20,
        20
      );
    },
    // 画布确定回调
    camConfirmOpt() {
      if (!this.x || !this.y || !this.areaCopy.id) {
        this.$message.warning("请选择所属楼栋及电气火灾的位置后提交数据");
        return;
      }
      this.showBuilding = false;
      this.devInData.buildingName = this.areaCopy.name;
      this.devInData.buildingCode = this.areaCopy.id;
      this.devInData.abscissa = this.x;
      this.devInData.ordinate = this.y;
      this.devInData.width = this.cW;
      this.devInData.height = this.cH;
      this.devInData.fileCode = this.fileCode;
      this.imgUrl = this.getImgPath(this.devInData.fileCode);
      console.log(this.devInData);
    },
    camCancleOpt() {
      this.showBuilding = false;
    },
    validateForm() {
      return new Promise(this.$refs.iocForm.validate);
    },
    clearValidate() {
      this.$refs.iocForm.clearValidate();
    },
    getAreaTree() {
      this.$fetch(api.deviceMan.queryAssociationalDeviceTree).then((res) => {
        this.areaTrData = res.returnObj;
      });
    },
    selectAreaNode(data) {
      this.deviceTreeShow = false;
      this.devInData.areaName = data.areaDevGroupName;
      this.devInData.areaCode = data.areaDevGroupCode;
      console.log(data);
    },
    initMap() {
      // this.$map.MapInstance2D.setMapOption()
      if (this.devInData.latitude) {
        this.getLocationCB([this.devInData.longitude, this.devInData.latitude]);
        this.$map.MapInstance2D.setMapCenter([
          this.devInData.longitude,
          this.devInData.latitude,
        ]);
      } else {
        this.$map.MapInstance2D.setMapCenter();
      }
      this.$map.MapInstance2D.resetMapStyle("map-container");
      this.$map.MapInstance2D.getLocation(this.getLocationCB);
    },
    getLocationCB(event) {
      this.point = event;
      let option = [
        {
          id: "point_" + new Date().getTime(),
          coord: this.point,
          src: "images/theme/newDark/map/resource/position_red.png",
        },
      ];
      this.$map.MapInstance2D.clearPoint();
      this.$map.MapInstance2D.addMarket(option);
    },
    openMap() {
      this.showMap = true;
      this.$nextTick(() => {
        this.$map.showMap2D(this.initMap);
      });
    },
    mapClose() {
      this.$map.hideMap2D();
    },
    // 点击地图框中的取消操作
    mapCancleOpt() {
      this.showMap = false;
      this.$map.hideMap2D();
    },
    mapConfirmOpt() {
      if (this.point) {
        this.devInData.longitude = Number(this.point[0]).toFixed(10);
        this.devInData.latitude = Number(this.point[1]).toFixed(10);
      }
      this.showMap = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-container {
  width: 100%;
  height: 40vh;
  overflow: auto;
  .position-set {
    position: relative;
  }
  .map-choose {
    position: absolute;
    right: -5px;
    top: 0px;
  }
  #map-container {
    height: 450px;
  }
  .flex-container {
    display: flex;
    margin-bottom: 10px;
    .left-tree {
      // width: 45%;
      // float: left;
      // display: inline;
      flex: 1;
      height: 500px;
    }
    .right-img {
      margin-top: 35px;
      margin-left: 10px;
      flex: 2;

      #building-img {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .canvasMain {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      .canvasMainT {
        position: absolute;
        img {
          width: 100%;
          height: 100%;
          position: absolute;
        }
        canvas {
          position: absolute;
        }
      }
    }
    .marTip {
      // position: absolute;
      // text-align: center;
      // right: 30px;
      // bottom: 20px;
      .restCanvas {
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
  .buildingDialog-footer {
    margin-top: 30px;
  }
}
</style>


